import { BadgeCheck, GraduationCap, Award, FileSpreadsheet, Briefcase } from "lucide-react";
import { QUALIFICATIONS } from "../data/content";
import { Reveal, SectionHeading } from "./Reveal";

const CERT_IMAGE =
  "https://customer-assets-4nw71qhi.emergentagent.net/job_wa-tech-help/artifacts/96fefc2996ef7605_cert_of_membership.png";

const ICONS = [BadgeCheck, GraduationCap, Award, FileSpreadsheet, Briefcase];

export default function Qualifications() {
  const bcs = QUALIFICATIONS[0];
  const rest = QUALIFICATIONS.slice(1);

  return (
    <section id="about" className="border-y border-white/5 bg-[#0A1128] py-20 md:py-28" data-testid="about-section">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <SectionHeading
          overline="About & qualifications"
          title="Qualified, certified and professionally accountable"
          copy="WA Digital Solutions is run by Wojciech Arseniuk — a computing professional with higher-education qualifications, advanced certified IT user skills and over three years of hands-on experience with data, spreadsheets, reporting and operational systems."
        />

        <div className="mt-12 grid gap-8 lg:grid-cols-[0.9fr_1.1fr]">
          <Reveal>
            <div
              className="relative h-full rounded-2xl border border-cyan-500/25 bg-[#0D152D] p-6 shadow-[0_0_44px_rgba(0,240,255,0.1)] md:p-8"
              data-testid="bcs-certificate-card"
            >
              <div className="flex items-center gap-2">
                <BadgeCheck size={18} className="text-cyan-400" />
                <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-cyan-300">
                  Professional body membership
                </p>
              </div>
              <h3 className="font-display mt-3 text-xl font-bold text-slate-50">
                {bcs.title} — {bcs.org}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-slate-400">{bcs.note}</p>

              <div className="mt-6 overflow-hidden rounded-xl border border-white/15 bg-white p-1.5 shadow-[0_18px_50px_rgba(0,0,0,0.5)]">
                <img
                  src={CERT_IMAGE}
                  alt="Certificate of BCS Membership — Mr Wojciech Arseniuk MBCS, Professional Member"
                  className="w-full rounded-lg"
                  data-testid="bcs-certificate-image"
                />
              </div>
              <div className="mt-4 flex flex-wrap gap-x-6 gap-y-1 font-mono text-[11px] text-slate-500">
                <span data-testid="bcs-membership-number">Membership no. 995132799</span>
                <span data-testid="bcs-validity">Valid until 15/07/2027</span>
              </div>
            </div>
          </Reveal>

          <div className="flex flex-col gap-4">
            {rest.map((q, i) => {
              const Icon = ICONS[i + 1];
              return (
                <Reveal key={q.title} delay={0.08 + i * 0.06}>
                  <div
                    data-testid={`qualification-card-${i}`}
                    className="group flex gap-5 rounded-2xl border border-white/10 bg-white/[0.03] p-6 transition-all duration-300 hover:border-cyan-500/30 hover:bg-white/[0.05]"
                  >
                    <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-cyan-500/10 text-cyan-400">
                      <Icon size={20} strokeWidth={1.8} />
                    </span>
                    <div>
                      <h3 className="font-display text-base font-semibold text-slate-50">{q.title}</h3>
                      <p className="font-mono text-[11px] uppercase tracking-[0.15em] text-slate-500">{q.org}</p>
                      <p className="mt-2 text-sm leading-relaxed text-slate-400">{q.note}</p>
                    </div>
                  </div>
                </Reveal>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
